import axios from 'axios'
import { API, graphqlOperation } from 'aws-amplify';
import * as mutations from '../../../graphql/mutations'
import * as queries from '../../../graphql/queries';

export default {
  namespaced: true,
  state: {
    financialSummary: '',
    lettingsForecast: '',
    salesForecast: ''
  },
  mutations: {
    SET_FINANCIAL_SUMMARY(state, data) {
      state.financialSummary = data
    },
    SET_LETTINGS_FORECAST(state, data){
      state.lettingsForecast = data;
    },
    SET_SALES_FORECAST(state, data){
      state.salesForecast = data;
    }
  },
	actions :  {
        getCompanySummary({commit, rootState}){
            return axios({
                method: 'GET',
                url: `${rootState.baseURL}/corporate/ownerapp/letmcletting/${rootState.user.ClientName}/financials/company/summary`,
                headers: {
                  token: rootState.user.LoginToken,
                  api_key: rootState.apiKey
                },
                params: {
                  startDate: rootState.reportMonthStart.format("YYYY-MM-DD"),
                  endDate: rootState.reportMonthEnd.format("YYYY-MM-DD")
                }
            }).then(function(response){
                commit('SET_FINANCIAL_SUMMARY', response.data)
            });
        },
        getLettingsForecast({commit, rootState}){
          API.graphql(
            graphqlOperation(queries.listForecasts, {
            filter: { 
                startDate:
                {"eq" : rootState.reportMonthStart },
                endDate : {
                    "eq" : rootState.reportMonthEnd
                },
                feeType: {
                    "eq" : "lettings"
                }
            }
          })).then(function(response){
            if (response.data.listForecasts.items[0] === undefined){
                commit('SET_LETTINGS_FORECAST', {amount : 0, id : 0})
            }
            else{
                commit('SET_LETTINGS_FORECAST', response.data.listForecasts.items[0]);
            }
          });
        },
        getSalesForecast({commit, rootState}){
          API.graphql(
            graphqlOperation(queries.listForecasts, {
            filter: { 
                startDate:
                {"eq" : rootState.reportMonthStart },
                endDate : {
                    "eq" : rootState.reportMonthEnd
                },
                feeType: {
                    "eq" : "sales"
                }
            }
          })).then(function(response){
            if (response.data.listForecasts.items[0] === undefined){
                commit('SET_SALES_FORECAST', {amount : 0, id : 0})
            }
            else{
                commit('SET_SALES_FORECAST', response.data.listForecasts.items[0]);
            }
          });
        },
        updateSalesForecast({commit}, payload){
          API.graphql({ query: mutations.updateForecast, variables: {input: payload}}).then(function(response){
              commit('SET_SALES_FORECAST',  response.data.updateForecast);
          }).catch(e => {
            console.log(e);
          });
        },
        updateLettingsForecast({commit}, payload){
          API.graphql({ query: mutations.updateForecast, variables: {input: payload}}).then(function(response){
              commit('SET_LETTINGS_FORECAST',  response.data.updateForecast);
          }).catch(e => {
            console.log(e);
          });
        },
        createLettingsForecast({commit}, payload){
          API.graphql({query: mutations.createForecast, variables: { input: payload } }).then(response => {
               commit('SET_LETTINGS_FORECAST',  response.data.createForecast);
           }).catch(e => {
               console.log(e);
           });
       },
        createSalesForecast({commit}, payload){
           API.graphql({query: mutations.createForecast, variables: { input: payload } }).then(response => {
                commit('SET_SALES_FORECAST',  response.data.createForecast);
            }).catch(e => {
                console.log(e);
            });
        }
    },
}